import { Controller } from '@hotwired/stimulus'

// Dismissal collapses the banner to a corner pill (per-pageview): fired
// moments are compliance nudges, so the full banner returns on the next
// page load while a moment is unanswered.
export default class extends Controller {
  static targets = ['banner', 'pill']

  dismiss() {
    this.bannerTarget.classList.add('d-none')
    this.pillTarget.classList.remove('d-none')
  }

  restore() {
    this.pillTarget.classList.add('d-none')
    this.bannerTarget.classList.remove('d-none')
  }
}
